import { tObject } from '../i18n';

interface Information {
  id: string,
  name: string,
  tooltip: string,
  moreInformation: string
}

const getInformation = (id: string): Information | undefined => {
  const information = tObject(`information.${id}`);
  return information ? { id, ...information } : undefined;
}

export { Information, getInformation };
